export default __webpack_public_path__ + "static/greg-mundy-7af79377bc622045a0193dcbf9dab33f.webp";